module.exports = "<div *ngIf=\"!accepted\" class=\"container-fluid cookie-warner\">\n  <div class=\"row\">\n    <div class=\"col-sm-11 cookie-warner-text\">\n      En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies techniques nécessaires au traitement de votre demande.\n    </div>\n    <div class=\"col-sm-1 cookie-warner-ok\">\n      <label type=\"button\" class=\"btn form-radio\" (click)=\"accept()\">Ok</label>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cookie-warner/cookie-warner.component.html
// module id = ./src/app/cookie-warner/cookie-warner.component.html
// module chunks = main